import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from "./pages/Login"
import AdminPage from "./pages/AdminPage";

function App() {
  const [isAuth, setIsAuth] = useState(localStorage.getItem('isAdmin') === 'true');

  return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login setAuth={setIsAuth} />} />
          <Route
              path="/admin"
              // Pass setIsAuth to AdminPage so it can handle Logout
              element={isAuth ? <AdminPage setAuth={setIsAuth} /> : <Navigate to="/login" />}
          />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
  );
}

export default App;